// extracted by mini-css-extract-plugin
export default {"carImg":"CarIcon_carImg__HBfiG","carIcon":"CarIcon_carIcon__GTVlE"};